import { Component,Inject,ViewChild,ElementRef } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { SeoService } from 'projects/hp-api/src/lib/services/seo.service';
import html2canvas from 'html2canvas';
export interface Subject {
  name: string;
}
export interface DataResp {
  insert: string;
}
const httpoptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/upload' , 'Accept': 'application/upload','Access-Control-Allow-Origin' : '*'})
}

@Component({
  selector: 'app-devis-form',
  templateUrl: './devis-form.component.html',
  styleUrls: ['./devis-form.component.css']
})
export class DevisFormComponent  {

  @ViewChild('canvas', {static: false}) canvas: ElementRef;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  devisForm: FormGroup;
  updateForme:FormGroup;
  isDisabled;
  infos:any;
  elementsInfo:any[];
  postId:any
  hasSent = false;
  beforeSending= false;
  photo_out;
  photo_in;
  passwordInputFocu = false;
  hide = true;
  dataInsert ={"insert":"3"};
  constructor(private hpService: HpService,
              private seo: SeoService,
              public fb: FormBuilder,
              private http: HttpClient,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.devisForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]]
      /*acceptTerms: [false, Validators.requiredTrue]*/

      });
    this.updateForme = this.fb.group({
        email: ['', Validators.required],
        password: ['', [Validators.required, Validators.minLength(6)]]
        /*acceptTerms: [false, Validators.requiredTrue]*/

        });


  }

  ngOnInit(): void {
 this.isDisabled = true;

  }

 /* Reactive form */
 reactiveForm() {
 }

 getValidator(){
  return this.devisForm.invalid;
 }
 // getter for easy access to form fields
 get f() { return this.devisForm.controls; }

 onFocusEvent(event: any){

  this.passwordInputFocu = true;

}





 postCoordination(){
  // Simple POST request with a JSON body and response type <any>
  this.hasSent = true;
 this.http.post<any>('/simulation/upload-image' , JSON.stringify({
  name: this.devisForm.value.name ,
  prenom:this.devisForm.value.prenom,
  email:this.devisForm.value.email,
  tel: this.devisForm.value.tel,
  adresse:this.devisForm.value.adresse,
  cp: this.devisForm.value.cp,
  ville:this.devisForm.value.ville,
  comment: this.devisForm.value.commentaire,
  type_demande:"D",
  param:"Null",
  have_Knowledge:"oui",
  accepte_com: "oui",
 id_profile:1,
 profile:"ouveo",
 uuid:"13cc854b-d64e-11e6-8513-000c29e2b856"})).subscribe(data => {
   this.postId = data.id;
   this.hasSent = false;
 })
  }

submitForm() {
  // stop here if form is invalid
  if (this.devisForm.invalid) {
    return;
}
this.sendForm();


}

registerForm() {
  // stop here if form is invalid
  if (this.devisForm.invalid) {
    return;
}

this.hasSent = true;

 this.http.post<any>('/simulation/simuleo/createUser' , JSON.stringify({
  email: this.devisForm.value.email ,
  pw:this.devisForm.value.password,
  partenaire:"swao",
  })).subscribe(data => {

    this.dataInsert = data;
    this.hasSent = false;
 });

}

updateForm()
{
  // stop here if form is invalid
  if (this.devisForm.invalid) {
    return;
}

this.hasSent = true;

 this.http.post<any>('/simulation/simuleo/createUser' , JSON.stringify({
  email: this.updateForme.value.email ,
  pw:this.updateForme.value.password,
  })).subscribe(data => {

    this.dataInsert = data;
    this.hasSent = false;
 });
}





downloadImageExt(): Promise<any> {
  return Promise.resolve((() => {
    html2canvas(document.querySelector("#screenExt")).then(canvas => {

      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/jpeg');
      this.downloadLink.nativeElement.download = 'ouveo-projet.jpeg';
      this.downloadLink.nativeElement.click();

      var dataURI = canvas.toDataURL('image/jpeg');
      let imgdata = dataURI.match(/data:(image\/.+);base64,(.+)/);
      let blob = this.dataURItoBlob(imgdata[2], imgdata[1]);
      let fd = new FormData();
      fd.append('blob', blob);
     this.seo.sharePost(fd,this.hpService.getView());


      });
    /*html2canvas(document.querySelector("#screenExt")).then(canvas => {

    let dataImage = canvas.toDataURL('image/jpeg');
    let data = canvas.toDataURL('image/jpeg');
    this.photo_out = data;
    let base64 =  {
      image: data
    }

    this.postData(data);
        console.log("1.....");
    })*/
      return 'from first'; // return whatever you want not neccessory
  })());
}

downloadImageInt(): Promise<any> {
  return Promise.resolve((() => {
    html2canvas(document.querySelector("#screenInt")).then(canvas => {

      var data = canvas.toDataURL('image/jpeg');
     // this.downloadLink.nativeElement.click();
      //window.saveAs(blob, 'image.png');
      this.http.post('/save_jpg.php', { data:data}).subscribe({

        next: data =>  console.log( "ok"),
        error: error => console.error('There was an error!', error)
    })

      return 'from second'; // return whatever you want not neccessory
    });
  })());
}

sendForm(){
   this.downloadImageExt().then(()=>{
     let photo_name  = this.seo.getImageName(this.hpService.getView());

    if( this.data.name === 'devis')
    {return}
    else
    {this.postCoordination();}
    });
  }

downloadImage(){

  switch(this.hpService.getView()){
    case '1':

  html2canvas(document.querySelector("#screenInt")).then(canvas => {
    this.canvas.nativeElement.src = canvas.toDataURL();
    this.downloadLink.nativeElement.href = canvas.toDataURL('image/jpeg');
    this.downloadLink.nativeElement.download = 'ouveo-projet.jpeg';
    this.downloadLink.nativeElement.click();
    return 'from second'; // return whatever you want not neccessory
  });
            break;
    default :
    html2canvas(document.querySelector("#screenExt")).then(canvas => {

      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/jpeg');
      this.downloadLink.nativeElement.download = 'ouveo-projet.jpeg';
      this.downloadLink.nativeElement.click();
      return 'from second'; // return whatever you want not neccessory

      });
  }
}

sharePhoto(){

  html2canvas(document.querySelector("#screenExt")).then(canvas => {

    this.canvas.nativeElement.src = canvas.toDataURL();
    this.downloadLink.nativeElement.href = canvas.toDataURL('image/jpeg');
    this.downloadLink.nativeElement.download = 'ouveo-projet.jpeg';
    this.downloadLink.nativeElement.click();

    var dataURI = canvas.toDataURL('image/jpeg');
    let imgdata = dataURI.match(/data:(image\/.+);base64,(.+)/);
    let blob = this.dataURItoBlob(imgdata[2], imgdata[1]);
    let fd = new FormData();
    fd.append('blob', blob);
    let nameImage
    nameImage = this.seo.sharePost(fd,'0');
    console.log(nameImage.fileName);


    });
}
dataURItoBlob(dataURI, mime) {
  let byteString = window.atob(dataURI);
  let ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
  ia[i] = byteString.charCodeAt(i);
  }
 let blob = new Blob([ia], { type: mime });
 return blob;
}

}
